// @Deprecated: This component is not used anymore, it was replaced by the UploadImageModal component
// To remove when we are done with the light mode transition

// Third-party
import React from 'react';
import cropperjs from 'cropperjs';

// Components
import { ImageUpload } from '../image-upload';
import { CancelButton } from '../buttons';
import Modal from '@/views/components/modals/AccessibleModal';

// Redux
import { cropUserImg } from '@/redux/modules/auth';

// Utils
import { FormattedMessage } from '../../../utils/i18n';
import { ReduxState } from '@/redux/modules/types';
import { connect } from 'react-redux';

// Types
import User from '@/types/user';

type StateProps = {
  user?: User | null;
};

type DispatchProps = {
  cropUserImg: (imgUrl: string, fileType: string, dimensions: cropperjs.Data) => Promise<string>;
};

type Props = StateProps &
  DispatchProps & {
    show: boolean;
    onCancel: () => void;
    titleId: string;
  };

const UploadPhotoModal = (props: Props) => {
  if (!props.user) {
    return null;
  }

  return (
    <Modal show={props.show} className="upload-image-modal" onHide={props.onCancel} dialogClassName="modal-dialog-centered">
      <Modal.Header closeButton>
        <Modal.Title>
          <FormattedMessage id={props.titleId} />
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="d-flex flex-column">
        <ImageUpload
          onSave={props.onCancel}
          aspectRatio={1}
          targetImg={props.user?.imgUrl}
          labelPrefix="PhotoUpload"
          onUpload={props.cropUserImg}
          errorKey="SAVE_PHOTO_ERROR"
        />
      </Modal.Body>

      <Modal.Footer className="justify-content-end">
        <CancelButton onClick={props.onCancel} />
      </Modal.Footer>
    </Modal>
  );
};
const mapStateToProps = (state: ReduxState) => ({
  user: state.auth.user,
});

export default connect(mapStateToProps, {
  cropUserImg,
})(UploadPhotoModal);
